import React from 'react';
import { NavLink } from 'react-router-dom';

import { CreditCard, Gauge, LayoutDashboard, UserRoundPen, Eye, EyeOff } from 'lucide-react';
import './sidebar-modern.scss';
import i18n from '../../../../i18n';
import { getLoggedUser } from '../../../../state/user';
import { getUserInfo } from '../../../../models/users';
import { getNotificationCounts } from '../../../../models/payments';
import { SideBarMob } from '../../sidebar-mob';
import { generateMzadcomID } from '../../../../state/utils';
import { flash } from 'react-animations';

const user = getLoggedUser();
let is_logged = localStorage.getItem('is_logged_in') ? true : false;
const allowed_roles = ['CE', 'GM'];

function logout() {
  localStorage.clear();
  window.location.href = '/';
}

export class SideBar extends React.Component {
  constructor() {
    super();
    this.state = {
      dashboard_menu_expand: false,
      report_menu_expand: false,
      wallet_amount: 0,
      showSensitiveInfo: false, // New state to toggle sensitive info,
      pendingMzadcomPayment: 0,
      pendingSupplierPayment: 0,
      pendingAuctionPayment: 0,
    };
    this.notificationCheck = this.notificationCheck.bind(this);
    this.toggleSensitiveInfo = this.toggleSensitiveInfo.bind(this);
  }

  componentDidMount() {
    if (user && allowed_roles.includes(user.role) ? true : false) {
      this.notificationCheck();
      setInterval(() => {
        this.notificationCheck();
      }, 60000);
    }
  }

  async checkUserWallet() {
    this.setState({ is_loading: true });
    const response = await getUserInfo(user.id);
    if (response && response.success) {
      let data = response.data;
      this.setState({ is_loading: false });
      this.setState({ wallet_amount: data.wallet_amount });
    } else {
      this.setState({ is_loading: false });
    }
  }

  async notificationCheck() {
    let response = await getNotificationCounts();
    let data = response.data;
    this.setState({
      pendingMzadcomPayment: data.mzadcom_payment_count,
      pendingSupplierPayment: data.supplier_auction_count,
      pendingAuctionPayment: data.auction_payment_count,
    });
  }

  toggleSensitiveInfo() {
    this.setState(prevState => ({
      showSensitiveInfo: !prevState.showSensitiveInfo
    }));
  }

  maskEmail(email) {
    if (!email) return '***';
    const [localPart, domain] = email.split('@');
    if (localPart.length <= 2) return '***';
    return localPart.substring(0, 2) + '***' + (domain ? '@' + domain : '');
  }

  maskMobile(mobile) {
    if (!mobile) return '***';
    if (mobile.length <= 4) return '***';
    return '***' + mobile.substring(mobile.length - 4);
  }


  render() {
    let { count, wallet_amount, showSensitiveInfo } = this.state;
    let lang = localStorage.getItem('I18N_LANGUAGE');
    return (
      <React.Fragment>
        {is_logged && (
          <div>
            <SideBarMob wallet_amount={wallet_amount} />
            <div className="modern-sidebar-container d-mob-none">
              {/* Dashboard Header */}
              <div className="modern-sidebar-header">
                <div className="header-icon-wrapper">
                  <LayoutDashboard className="header-icon" />
                </div>
                <span className="header-title">{i18n.t('dashboard')}</span>
              </div>

              <div className="modern-sidebar-content">
                {/* User Profile Card */}
                <div className="modern-profile-card">
                  <div className="profile-avatar-section">
                    {user.avatar ? (
                      <img
                        src={user.avatar}
                        alt="user"
                        className="profile-avatar"
                        referrerPolicy="no-referrer"
                      />
                    ) : (
                      <img
                        src={process.env.PUBLIC_URL + '/assets/images/admin-user-icon.png'}
                        alt="Admin User Icon"
                        className="profile-avatar"
                      />
                    )}
                  </div>

                  <div className="profile-info-section">
                    <h3 className="profile-name">{user.name}</h3>
                    <p className="profile-email" onClick={() => this.setState(prevState => ({ showSensitiveInfo: !prevState.showSensitiveInfo }))}>{showSensitiveInfo ? user.email : this.maskEmail(user.email)}</p>
                  </div>


                  <div className="profile-details-section">

                    <div className="profile-detail-item">
                      <span className="detail-label">{i18n.t('mobile')}:</span>
                      <span className="detail-value" onClick={() => this.setState(prevState => ({ showSensitiveInfo: !prevState.showSensitiveInfo }))}>
                        {showSensitiveInfo ? user.mobile : this.maskMobile(user.mobile)}
                      </span>
                    </div>

                    <div className="profile-detail-item">
                      <span className="detail-label">{i18n.t('mzadcom_id')}:</span>
                      <span className="detail-value">{generateMzadcomID(user.id, user.role)}</span>
                    </div>

                    <div className="profile-detail-item">
                      <span className="detail-label">{i18n.t('role')}:</span>
                      <span className="detail-value">{user.role === "A" ? "ADMIN" :
                        user.role === "CE" ? "CEO" : user.role === "GM" ? "GENERAL MANAGER" :
                          user.role === "M" ? "MANAGER" : user.role === "C" ? "CLIENT" :
                            user.role === "PM" ? "PROJECT MANAGER" : user.role === "OM" ? "OPERATION_MANAGER" :
                              user.role === "HSE" ? "HSE" : user.role === "F" ? "FINANCE_MANAGER" :
                                user.role === "FS" ? "FINANCE_SUPPORT" : "BIDDER"}</span>
                    </div>

                  </div>
                </div>

                <div className="profile-divider"></div>

                {/* Navigation Menu */}
                <nav className="modern-nav-menu">
                  {['CE', 'GM'].includes(user.role) && (
                    <NavLink
                      activeClassName="nav-link-active"
                      to="/management"
                      className="modern-nav-link"
                    >
                      <img
                        src={process.env.PUBLIC_URL + '/assets/images/dashboard-sub1.png'}
                        alt=""
                        className="nav-icon"
                      />
                      <span>{i18n.t('management_dashboard')}</span>
                    </NavLink>
                  )}

                  {['U', 'CE', 'GM'].includes(user.role) && (
                    <NavLink
                      activeClassName="nav-link-active"
                      to="/dashboard"
                      className="modern-nav-link"
                    >
                      <img
                        src={process.env.PUBLIC_URL + '/assets/images/dashboard-sub1.png'}
                        alt=""
                        className="nav-icon"
                      />
                      <span>{i18n.t('dashboard')}</span>
                    </NavLink>
                  )}

                  {!['U', 'CE', 'GM'].includes(user.role) && (
                    <div className="nav-group">
                      <button
                        className="modern-nav-link nav-group-trigger"
                        onClick={() => {
                          this.setState({
                            dashboard_menu_expand: !this.state.dashboard_menu_expand,
                          });
                        }}
                      >
                        <img
                          src={process.env.PUBLIC_URL + '/assets/images/dashboard-left-menu-icon.png'}
                          alt=""
                          className="nav-icon"
                        />
                        <span>{i18n.t('dashboard')}</span>
                        <i className={`expand-icon ${this.state.dashboard_menu_expand ? 'expanded' : ''}`}>
                          <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                            <path d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" />
                          </svg>
                        </i>
                      </button>
                      <div className={`nav-submenu ${this.state.dashboard_menu_expand ? 'expanded' : ''}`}>
                        <NavLink
                          activeClassName="nav-link-active"
                          to="/dashboard"
                          className="modern-nav-link submenu-link"
                        >
                          <img
                            src={process.env.PUBLIC_URL + '/assets/images/dashboard-sub1.png'}
                            alt=""
                            className="nav-icon"
                          />
                          <span>{i18n.t('live_dashboard')}</span>
                        </NavLink>
                        <NavLink
                          activeClassName="nav-link-active"
                          to="/dashboard-auc-eval"
                          className="modern-nav-link submenu-link"
                        >
                          <img
                            src={process.env.PUBLIC_URL + '/assets/images/dashboard-sub2.png'}
                            alt=""
                            className="nav-icon"
                          />
                          <span>{i18n.t('auction_evaluation')}</span>
                        </NavLink>
                        <NavLink
                          activeClassName="nav-link-active"
                          to="/dashboard-user-analysis"
                          className="modern-nav-link submenu-link"
                        >
                          <img
                            src={process.env.PUBLIC_URL + '/assets/images/dashboard-sub3.png'}
                            alt=""
                            className="nav-icon"
                          />
                          <span>{i18n.t('user_analysis')}</span>
                        </NavLink>
                        <NavLink
                          activeClassName="nav-link-active"
                          to="/dashboard-sales-eval"
                          className="modern-nav-link submenu-link"
                        >
                          <img
                            src={process.env.PUBLIC_URL + '/assets/images/dashboard-sub4.png'}
                            alt=""
                            className="nav-icon"
                          />
                          <span>{i18n.t('sales_evaluation')}</span>
                        </NavLink>
                      </div>
                    </div>
                  )}

                  <NavLink activeClassName="nav-link-active" to="/profile" className="modern-nav-link">
                    {/* <i className="icon icon-user nav-icon"></i> */}
                    <UserRoundPen className='nav-icon' />
                    <span>{i18n.t('edit_profile')}</span>
                  </NavLink>

                  {(user.role === 'A' ||
                    user.role === 'PM' ||
                    user.role === 'OM' ||
                    user.role === 'GM' ||
                    user.role === 'CE' ||
                    user.role === 'M') && (
                      <>
                        <NavLink
                          to="/live_activity"
                          activeClassName="nav-link-active"
                          className="modern-nav-link"
                          target="_blank"
                        >
                          <i className="fa fa-desktop nav-icon"></i>
                          <span>{i18n.t('live_activity')}</span>
                        </NavLink>

                        <NavLink
                          to="/users"
                          activeClassName="nav-link-active"
                          className="modern-nav-link"
                        >
                          <i className="fa fa-users nav-icon"></i>
                          <span>{i18n.t('users')}</span>
                        </NavLink>

                        <NavLink
                          to="/clients"
                          activeClassName="nav-link-active"
                          className="modern-nav-link"
                        >
                          <i className="mdi mdi-account-multiple nav-icon"></i>
                          <span>{i18n.t('clients')}</span>
                        </NavLink>
                      </>
                    )}

                  {(user.role === 'A' ||
                    user.role === 'C' ||
                    user.role === 'PM' ||
                    user.role === 'OM' ||
                    user.role === 'GM' ||
                    user.role === 'CE' ||
                    user.role === 'F' ||
                    user.role === 'M') && (
                      <NavLink
                        activeClassName="nav-link-active"
                        to="/enrolled_users"
                        className="modern-nav-link"
                      >
                        <i className="fa fa-user-plus nav-icon"></i>
                        <span>{i18n.t('enrolled_users')}</span>
                      </NavLink>
                    )}

                  {['F'].includes(user.role) && (
                    <NavLink
                      to="/auction-payment"
                      activeClassName="nav-link-active"
                      className="modern-nav-link"
                    >
                      <CreditCard className="nav-icon" size={20} />
                      <span>{i18n.t('auction_payments')}</span>
                      <div>{user.role === 'F' && this.state.pendingAuctionPayment > 0 && (
                        <span className="count-badge">{this.state.pendingAuctionPayment}</span>
                      )}</div>
                    </NavLink>
                  )}

                  {['A', 'F', 'CE', 'GM'].includes(user.role) && (
                    <>
                      <NavLink
                        to="/users-wallet"
                        activeClassName="nav-link-active"
                        className="modern-nav-link"
                      >
                        <i className="fa fa-money nav-icon"></i>
                        <span>{i18n.t('mzadcom')} - {i18n.t('wallet')}</span>
                      </NavLink>
                      <NavLink
                        to="/withdraw-requests"
                        activeClassName="nav-link-active"
                        className="modern-nav-link"
                      >
                        <i className="fa fa-undo nav-icon"></i>
                        <span>{i18n.t('withdraw_requests')}</span>
                      </NavLink>
                    </>
                  )}

                  {user.role === 'A' && (
                    <>
                      <NavLink
                        to="/groups"
                        activeClassName="nav-link-active"
                        className="modern-nav-link"
                      >
                        <i className="fa fa-object-group nav-icon"></i>
                        <span>{i18n.t('groups')}</span>
                      </NavLink>
                      <NavLink to="/masks" activeClassName="nav-link-active" className="modern-nav-link">
                        <i className="icon icon-layers nav-icon"></i>
                        <span>{i18n.t('masks')}</span>
                      </NavLink>
                      <NavLink
                        to="/categories"
                        activeClassName="nav-link-active"
                        className="modern-nav-link"
                      >
                        <i className="fa fa-list-alt nav-icon"></i>
                        <span>{i18n.t('categories')}</span>
                      </NavLink>
                      <NavLink
                        to="/organizations"
                        activeClassName="nav-link-active"
                        className="modern-nav-link"
                      >
                        <i className="fa fa-building nav-icon"></i>
                        <span>{i18n.t('organizations')}</span>
                      </NavLink>
                      <NavLink
                        to="/banners"
                        activeClassName="nav-link-active"
                        className="modern-nav-link"
                      >
                        <i className="fa fa-image nav-icon"></i>
                        <span>{i18n.t('banners')}</span>
                      </NavLink>
                      <NavLink
                        to="/blacklist"
                        activeClassName="nav-link-active"
                        className="modern-nav-link"
                      >
                        <i className="fa fa-ban nav-icon"></i>
                        <span>{i18n.t('blacklist')}</span>
                      </NavLink>
                      <NavLink
                        to="/create_auction"
                        activeClassName="nav-link-active"
                        className="modern-nav-link"
                      >
                        <i className="icon icon-plus nav-icon"></i>
                        <span>{i18n.t('create_auction')}</span>
                      </NavLink>
                    </>
                  )}

                  {(user.role === 'A' ||
                    user.role === 'C' ||
                    user.role === 'PM' ||
                    user.role === 'OM' ||
                    user.role === 'GM' ||
                    user.role === 'CE' ||
                    user.role === 'M') && (
                      <NavLink
                        to="/auctions_list"
                        activeClassName="nav-link-active"
                        className="modern-nav-link"
                      >
                        <i className="icon icon-diamond nav-icon"></i>
                        <span>{i18n.t('my_auctions')}</span>
                      </NavLink>
                    )}

                  {(user.role === 'A' ||
                    user.role === 'PM' ||
                    user.role === 'OM' ||
                    user.role === 'F') && (
                      <NavLink
                        to="/auction_approval"
                        activeClassName="nav-link-active"
                        className="modern-nav-link"
                      >
                        <img
                          src={process.env.PUBLIC_URL + '/assets/images/image 25.png'}
                          alt=""
                          className="nav-icon"
                        />
                        <span>{user.role === 'F' ? i18n.t('supplier_payment') : i18n.t('auction_approval')}</span>
                        <div>{user.role === 'F' && this.state.pendingSupplierPayment > 0 && (
                          <span className="count-badge">{this.state.pendingSupplierPayment}</span>
                        )}</div>
                      </NavLink>
                    )}

                  {user.role === 'A' && (
                    <NavLink
                      to="/approved_auctions"
                      activeClassName="nav-link-active"
                      className="modern-nav-link"
                    >
                      <i className="mdi mdi-checkbox-marked-circle-outline nav-icon"></i>
                      <span>{i18n.t('approved_auctions')}</span>
                    </NavLink>
                  )}

                  {user.role === 'U' && (
                    <>
                      <NavLink
                        activeClassName="nav-link-active"
                        to="/my_auctions"
                        className="modern-nav-link"
                      >
                        <img
                          src={process.env.PUBLIC_URL + '/assets/images/solar_key-outline.png'}
                          alt=""
                          className="nav-icon"
                        />
                        <span>{i18n.t('my_bids')}</span>
                      </NavLink>
                      <NavLink
                        activeClassName="nav-link-active"
                        to="/enrolled_auctions"
                        className="modern-nav-link"
                      >
                        <img
                          src={process.env.PUBLIC_URL + '/assets/images/auctions-left-menu-icon.png'}
                          alt=""
                          className="nav-icon"
                        />
                        <span>{i18n.t('enrolled_auctions')}</span>
                      </NavLink>
                      <NavLink
                        activeClassName="nav-link-active"
                        to="/winning_bids"
                        className="modern-nav-link"
                      >
                        <i className="icon icon-trophy nav-icon"></i>
                        <span>{i18n.t('winning_bids')}</span>
                      </NavLink>
                    </>
                  )}

                  {['U'].includes(user.role) && (
                    <NavLink
                      to="/mzadcom-payment"
                      activeClassName="nav-link-active"
                      className="modern-nav-link"
                    >
                      <CreditCard className="nav-icon" size={20} />
                      <span>{i18n.t('mzadcom_payment')}</span>

                      <div> {this.state.pendingMzadcomPayment > 0 && (
                        <span className="count-badge">{this.state.pendingMzadcomPayment}</span>
                      )}</div>
                    </NavLink>
                  )}

                  <NavLink
                    activeClassName="nav-link-active"
                    to="/site_visit"
                    className="modern-nav-link"
                  >
                    <i className="icon icon-credit-card nav-icon"></i>
                    <span>{i18n.t('site_visit')}</span>
                  </NavLink>

                  {user.role === 'U' && (
                    <NavLink
                      activeClassName="nav-link-active"
                      to="/wallet"
                      className="modern-nav-link"
                    >
                      <img
                        src={process.env.PUBLIC_URL + '/assets/images/mzadcom-wallet-left-menu-icon.png'}
                        alt=""
                        className="nav-icon"
                      />
                      <span>{i18n.t('my_wallet')}</span>
                    </NavLink>
                  )}

                  {(user.role === 'A' || user.role === 'C' || user.role === 'M') && (
                    <NavLink
                      activeClassName="nav-link-active"
                      to="/payments"
                      className="modern-nav-link"
                    >
                      <i className="icon icon-credit-card nav-icon"></i>
                      <span>{i18n.t('payment')}</span>
                    </NavLink>
                  )}

                  {(user.role === 'A' || user.role === 'PM' || user.role === 'OM') && (
                    <NavLink
                      activeClassName="nav-link-active"
                      to="/client-payments"
                      className="modern-nav-link"
                    >
                      <i className="mdi mdi-bank nav-icon"></i>
                      <span>{i18n.t('client_payment')}</span>
                    </NavLink>
                  )}

                  {(user.role === 'A' ||
                    user.role === 'PM' ||
                    user.role === 'F' ||
                    user.role === 'OM' ||
                    user.role === 'GM' ||
                    user.role === 'CE') && (
                      <NavLink
                        activeClassName="nav-link-active"
                        to="/refund"
                        className="modern-nav-link"
                      >
                        <i className="fa fa-money nav-icon"></i>
                        <span>{i18n.t('refund')}</span>
                        {allowed_roles.includes(user.role) && count > 0 && (
                          <span className="notification-badge">{count}</span>
                        )}
                      </NavLink>
                    )}

                  <NavLink
                    activeClassName="nav-link-active"
                    to="/auction_tracker"
                    className="modern-nav-link"
                  >
                    <i className="mdi mdi-history nav-icon"></i>
                    <span>{i18n.t('track_auctions')}</span>
                  </NavLink>

                  <NavLink
                    activeClassName="nav-link-active"
                    to="/auction_liked"
                    className="modern-nav-link"
                  >
                    <i className="icon icon-like nav-icon"></i>
                    <span>{i18n.t('liked_auctions')}</span>
                  </NavLink>

                  <NavLink
                    activeClassName="nav-link-active"
                    to="/auction_wishlisted"
                    className="modern-nav-link"
                  >
                    <i className="icon icon-heart nav-icon"></i>
                    <span>{i18n.t('wishlisted_auctions')}</span>
                  </NavLink>

                  {(user.role === 'A' ||
                    user.role === 'C' ||
                    user.role === 'PM' ||
                    user.role === 'OM' ||
                    user.role === 'GM' ||
                    user.role === 'CE' ||
                    user.role === 'F' ||
                    user.role === 'M') && (
                      <div className="nav-group">
                        <button
                          className="modern-nav-link nav-group-trigger"
                          onClick={() => {
                            this.setState({
                              report_menu_expand: !this.state.report_menu_expand,
                            });
                          }}
                        >
                          <i className={`${this.state.report_menu_expand ? 'fa fa-minus' : 'fa fa-plus'} nav-icon`}></i>
                          <span>{i18n.t('reports')}</span>
                          <i className={`expand-icon ${this.state.report_menu_expand ? 'expanded' : ''}`}>
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                              <path d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" />
                            </svg>
                          </i>
                        </button>
                        <div className={`nav-submenu ${this.state.report_menu_expand ? 'expanded' : ''}`}>
                          <NavLink
                            activeClassName="nav-link-active"
                            to="/auction_bid_report"
                            className="modern-nav-link submenu-link"
                          >
                            <i className="fa fa-file-o nav-icon"></i>
                            <span>{i18n.t('auction_bid_report')}</span>
                          </NavLink>
                          <NavLink
                            activeClassName="nav-link-active"
                            to="/winners"
                            className="modern-nav-link submenu-link"
                          >
                            <i className="fa fa-flag-o nav-icon"></i>
                            <span>{i18n.t('auction_winners')}</span>
                          </NavLink>
                          {(user.role === 'A' ||
                            user.role === 'PM' ||
                            user.role === 'OM' ||
                            user.role === 'GM' ||
                            user.role === 'CE' ||
                            user.role === 'M') && (
                              <>
                                <NavLink
                                  to="/sales_report"
                                  activeClassName="nav-link-active"
                                  className="modern-nav-link submenu-link"
                                >
                                  <i className="fa fa-money nav-icon"></i>
                                  <span>{i18n.t('sales_report')}</span>
                                </NavLink>
                                <NavLink
                                  to="/final_report"
                                  activeClassName="nav-link-active"
                                  className="modern-nav-link submenu-link"
                                >
                                  <i className="fa fa-hourglass-end nav-icon"></i>
                                  <span>{i18n.t('final_report')}</span>
                                </NavLink>
                                <NavLink
                                  to="/position_report"
                                  activeClassName="nav-link-active"
                                  className="modern-nav-link submenu-link"
                                >
                                  <i className="fa fa-key nav-icon"></i>
                                  <span>{i18n.t('position_report')}</span>
                                </NavLink>
                                <NavLink
                                  to="/wallet_summary"
                                  activeClassName="nav-link-active"
                                  className="modern-nav-link submenu-link"
                                >
                                  <i className="fa fa-google-wallet nav-icon"></i>
                                  <span>{i18n.t('wallet_summary')}</span>
                                </NavLink>
                              </>
                            )}
                          <NavLink
                            to="/reports"
                            activeClassName="nav-link-active"
                            className="modern-nav-link submenu-link"
                          >
                            <i className="icon icon-chart nav-icon"></i>
                            <span>{i18n.t('reports')}</span>
                          </NavLink>
                        </div>
                      </div>
                    )}

                  {(user.role === 'A' ||
                    user.role === 'PM' ||
                    user.role === 'OM' ||
                    user.role === 'GM' ||
                    user.role === 'CE' ||
                    user.role === 'M') && (
                      <NavLink
                        to="/composer"
                        activeClassName="nav-link-active"
                        className="modern-nav-link"
                      >
                        <i className="fa fa-bell-o nav-icon"></i>
                        <span>{i18n.t('composer')}</span>
                      </NavLink>
                    )}

                  <button onClick={logout} className="modern-nav-link logout-link">
                    <i className="icon icon-power nav-icon"></i>
                    <span>{i18n.t('logout')}</span>
                  </button>
                </nav>
              </div>
            </div>
          </div>
        )}
      </React.Fragment>
    );
  }
}